module.exports = __webpack_public_path__ + "static/media/23.7cb2d640.JPG";